module.exports = __webpack_public_path__ + "7930e820.png";